import { markPrerendered } from "@/lib/prerender";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppProviders, ROUTER_FUTURE } from "./AppProviders";
// tailwind·globals 가 이미 Pretendard 를 지정하고 있었지만 정작 웹폰트를 싣지 않아 기기 글꼴로
// 대체되고 있었다. 다이내믹 서브셋이라 화면에 쓰인 글자 조각만 내려받는다.
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const app = (
  <AppProviders>
    <BrowserRouter future={ROUTER_FUTURE}>
      <App />
    </BrowserRouter>
  </AppProviders>
);

// 색인 허용 경로(/, /guide …)는 빌드 때 프리렌더된 HTML 로 온다(scripts/prerender.ts).
// 그 마크업을 버리고 다시 그리면 lazy 청크가 오는 동안 본문이 비었다가 나타나므로 hydrate 한다.
// 나머지 경로(게스트 챗·콘솔)는 빈 셸이라 그냥 그린다.
if (rootElement.hasChildNodes()) {
  markPrerendered(window.location.pathname);
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
